import { useCallback } from 'react';
import { getScenarioDetail } from '../api/tumblerApi';
import useScopedLoad from './useScopedLoad';
export default function useScenarioDetail({ scenarioId, accessToken }) {
  const loader = useCallback(async (signal) => (await getScenarioDetail({ scenarioId, accessToken, signal })).data, [scenarioId, accessToken]);
  const state = useScopedLoad(String(scenarioId), loader, Boolean(scenarioId && accessToken));
  return { ...state, scenario: state.data };
}
